import {
  ClientFieldDataType,
  transformCoverages,
} from 'QuoteApp/services/endpoints/GetDetails';

type DetailsCoveragesType = ReturnType<typeof transformCoverages>;

type ErrorValue = string | string[];

export type CoverageErrorMap = Record<string, ErrorValue>;

const extractCoverageErrors = (errorCode: string) => {
  const getErrorMessage = (
    coverage: ClientFieldDataType,
    key: string
  ): CoverageErrorMap => {
    const matching = (coverage.errors ?? []).filter(
      (e) => e.errorCode === errorCode
    );
    if (matching.length === 0) {
      return {};
    }
    // Single match: preserve original array if message was array
    if (matching.length === 1) {
      const { message } = matching[0];
      if (Array.isArray(message)) {
        return { [key]: message };
      }
      return { [key]: message };
    }
    // Multiple matches: flatten all messages into an array
    const messages: string[] = matching.flatMap((e) =>
      Array.isArray(e.message) ? e.message : [e.message]
    );
    return { [key]: messages };
  };

  const reduceErrors = (
    items: Record<string, ClientFieldDataType>
  ): CoverageErrorMap =>
    Object.entries(items).reduce<CoverageErrorMap>((acc, [key, cov]) => {
      return { ...acc, ...getErrorMessage(cov, key) };
    }, {});

  return (coverages: DetailsCoveragesType) => ({
    policy: reduceErrors(coverages.policy),
    vehicles: Object.fromEntries(
      Object.entries(coverages.vehicles).map(([vid, covered]) => [
        vid,
        reduceErrors(covered),
      ])
    ),
  });
};

export const getHealedCoverages = extractCoverageErrors('healedCoverage');
export const getCoverageErrors = extractCoverageErrors('schemaError');
